import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react'
import { cartMobx, doComboMobx, doProductMobx, productMobx, productSaleMobx, storeMobx, restaurantConfig } from 'restaurant'
import { decorationMobx, timePickMobx, eatTypeStatusMobx, thirdPartyMobx, buyTogetherMobx } from '@mobxStore'
import { showMsg, useHistoryNew, modalLayer, formatTimeByToday } from '@utils'
import { BackPageBtn } from '@cps'
import { AboardModify, AboardScale, CnScales, CnModify, DetailInfo, Footer, Reserve } from '../'
import CashierController from 'controllers/cashierController'
import TimePickController from '@ctrls/timePickController'
import { flatten, map } from '@dt/fe-utils/dist/lodash'
import { classNames, useThrottle } from '@dt/fe-utils'
import ScrollController from '@ctrls/scrollController'

interface IProps {
  isModal?: boolean;
  maxCnt?: number;
  showInfo?: boolean;
  targetType?: string;
  targetNo?: string;
  disableScale?: boolean;
  hideModifyDiscount?: boolean;
}

const ProductDetail: FC<IProps> = ({ isModal, maxCnt, showInfo, targetType, targetNo, disableScale, hideModifyDiscount }) => {
  const [tt, setTargetType] = useState(targetType)
  const [subcolor, setSubcolor] = useState('wrong')
  const { name, intro, picBig, picHeight, picWidth, allergys, tags, pk, isCanTogo, pics, salesCnt = 1, showType = 0, maxSalesCnt } = doProductMobx.doProduct
  const [singleNo, setSindleNo] = useState<string>('')
  const [wrongFlag, setWrongFlag] = useState(false)
  const [canScroll, setCanScroll] = useState(true)
  const [scrollTop, setScrollTop] = useState(0)
  const history = useHistoryNew()
  const isCombo = targetType === 'combo'
  const isFromRecommend = history.getPrevState().includes('/recommend/')

  const targetRef = useRef(null)

  const cartItems = Config.buyTogetherId ? buyTogetherMobx.cartFormMenu : cartMobx.cartItems
  // 起售份数按餐品维度判断：同一餐品任一规格已满足起售后，切换规格也是追加 1 份。
  const isProductInCart = !isCombo && cartItems.some(item => item.productNo === doProductMobx.doProduct.no && item.cnt > 0)
  const addSalesCnt = isProductInCart ? 1 : salesCnt

  const isRestingStore = useMemo(() => {
    if (restaurantConfig.codeType !== 'brand' && cartMobx.info.payMode) {
      return !storeMobx.info?.inSale
    } else {
      return !(restaurantConfig.codeType === 'brand' ? (!!(timePickMobx.canPick && storeMobx.info.isMobileBookingOrder) || storeMobx.info.inSale) : storeMobx.info.inSale)
    }
  }, [storeMobx.info, cartMobx.info])

  const isOptionalComboGroupFull = useMemo(() => {
    const groupCnt = doComboMobx.doComboResult?.groupNoToTypeCntMap[targetNo]
    const isOptionalCombo = doComboMobx.doComboType === 'OptionalCombo'
    const selectMin = doComboMobx.doCombo?.productGroups?.find(group => group.no === targetNo)?.selectMin
    return isOptionalCombo && groupCnt && groupCnt === selectMin && !pk
  }, [doComboMobx.doComboType, doComboMobx.doCombo, doProductMobx.doProduct, targetNo])

  const isCanAddCart = useMemo(() => {
    return CashierController.checkCanCart()
  }, [eatTypeStatusMobx.hasEnableEatType, storeMobx.info, timePickMobx.timePickList])

  const handleBack = (hs = history, isC = isCombo, isF = isFromRecommend) => {
    try {
      if (!isModal) {
        (hs && !isC && !isF && (hs.length <= 2 || !hs.getPrevState()) ? hs.push('/menu') : hs.goBack())
      } else {
        modalLayer.close('ProductDetail')
      }
    } catch (error) { }
  }

  const handleExChange = useThrottle((targetNo?: string) => {
    if (doProductMobx.doProductResult.isReady) {
      CashierController.handleAddSwapBuyToCart(doProductMobx.doProduct, targetNo, () => {
        handleBack(history, targetRef.current?.targetType === 'combo', isFromRecommend)
      })
    } else {
      setSubcolor('colorred')
      handleScollWrong()
    }
  }, 1000)

  const handleFullNFree = useThrottle((targetNo?: string) => {
    if (doProductMobx.doProductResult.isReady) {
      cartMobx.addFullNFreeToCart(doProductMobx.doProduct, targetNo)
      handleBack(history, targetRef.current?.targetType === 'combo', isFromRecommend)
    } else {
      setSubcolor('colorred')
      handleScollWrong()
    }
  }, 1000)

  const handleCombo = useThrottle(() => {
    if (isOptionalComboGroupFull) {
      return
    }
    if (doProductMobx.doProduct.saleCnt === 0) {
      return
    }
    if (doProductMobx.doProductResult.isReady) {
      if (doProductMobx.checkInvalid()) {
        showMsg(i18n.t('productdetail.saleOutTips2'))
        return
      }
      doComboMobx.addToCombo(doProductMobx.doProduct)
      handleBack(history, targetRef.current?.targetType === 'combo', isFromRecommend)
    } else {
      setSubcolor('colorred')
      handleScollWrong()
    }
  }, 1000)

  const handleOrderSwaBuy = useThrottle(() => {
    if (doProductMobx.doProductResult.isReady) {
      if (doProductMobx.doProduct && doProductMobx.doProduct.cnt) {
        CashierController.handleAddToCart(doProductMobx.doProduct.type, () => {
          handleBack(history, targetRef.current?.targetType === 'combo', isFromRecommend)
        })
      } else {
        cartMobx.remove(doProductMobx.doProduct.pk)
        handleBack(history, targetRef.current?.targetType === 'combo', isFromRecommend)
      }
    } else {
      setSubcolor('colorred')
      handleScollWrong()
    }
  }, 1000)

  const handleScollWrong = () => {
    const productContent: any = document.getElementById('productContent')
    const childNodes: any = document.querySelector(
      '.choose-modify-list'
    )?.childNodes
    const index = doProductMobx.doProduct.modifierGroups.findIndex(
      (group) => !group.isReady
    )
    if (productContent && childNodes && ~index) {
      productContent.scrollToPoint(0, childNodes[index].offsetTop, 300)
    }
    setWrongFlag(true)
    document.querySelector('ion-content').scrollToBottom()
  }

  // 处理首页滚动
  const handleOnScroll = useThrottle((e: any) => {
    if (!canScroll) return
    const scrollTop = typeof e === 'number' ? e : (e.detail?.scrollTop || 0)
    if (scrollTop < 0) {
      return false
    }
    setScrollTop(scrollTop)
  }, 100)

  /** 规格加料数量超过6个展示全部加料，大图会被遮挡 */
  const hasFullOperate = useMemo(() => {
    const { scales, modifierGroups } = doProductMobx.doProduct
    return [...scales, ...flatten(map(modifierGroups, 'modifiers'))].length > 6
  }, [doProductMobx.doProduct.no])

  const disableTogo = cartMobx.info.eatType !== 'dinein' && !doProductMobx.doProduct.isCanTogo

  const disableReserve = timePickMobx.canBookingTime && (timePickMobx.productRuleMap?.[doProductMobx.doProduct.no] && !timePickMobx.productTimePickList?.length)

  useEffect(() => {
    doProductMobx.setCnt(addSalesCnt)
  }, [addSalesCnt])

  useEffect(() => {
    if (targetType === 'combo' && targetNo) {
      targetRef.current = {
        targetType,
        targetNo
      }
    }
  }, [targetType])

  useEffect(() => {
    if (!['combo', 'fullNFree'].includes(targetType) && timePickMobx.productRuleMap?.[doProductMobx.doProduct.no]) {
      TimePickController.handleInitProduct(doProductMobx.doProduct.no)
    }
  }, [doProductMobx.doProduct, timePickMobx.productRuleMap?.[doProductMobx.doProduct.no]])

  const productMinPrice = useMemo(() => {
    const scales = doProductMobx.doProduct.scales || []
    const priceArr = scales.map(scale => scale.price)
    const price = Math.min(...priceArr)
    return price
  }, [doProductMobx.doProduct])

  useIonViewWillEnter(() => {
    setCanScroll(true)
  }, [])

  useIonViewDidLeave(() => {
    setCanScroll(false)
  }, [])

  return (
    <>
      <IonContent
        scrollEvents
        onIonScrollStart={() => (ScrollController.isScrolling = true)}
        onIonScrollEnd={(e) => {
          ScrollController.isScrolling = false
        }}
        onIonScroll={(e) => {
          handleOnScroll(e)
        }}
        id='productContent'
      >
        <div id='productScrollWrapper'>
          {isModal ? <div className='detail-page-mask' data-cypid='productDetailClose' onClick={() => handleBack()}></div> : <BackPageBtn onClick={() => handleBack()} />}
          {showInfo && (
            <DetailInfo
              no={doProductMobx.doProduct.no}
              imgUrl={picBig}
              pics={pics}
              picHeight={picHeight}
              picWidth={picWidth}
              name={name}
              intro={intro}
              allergys={allergys}
              tags={tags}
              showType={showType}
              statSaleCnt={
                decorationMobx.mealDecorates.showMonthSales ? doProductMobx.doProduct.statSaleCnt : 0
              }
              inventoryCnt={
                decorationMobx.mealDecorates.showSalesCnt ? productSaleMobx.productNoToScaleCntMap[doProductMobx.doProduct.no]?.cnt : 0
              }
              salesCnt={salesCnt}
              hasFullOperate={hasFullOperate}
              isCanTogo={isCanTogo}
              isModal={isModal}
              scrollTop={scrollTop}
              price={productMinPrice}
            >
              {bo === 'cn' ? (
                <div className='cn-scale-modify'>
                  <CnScales disableScale={disableScale} hidePrice={disableScale} />
                  <CnModify subsColor={subcolor} hideModifyDiscount={hideModifyDiscount} />
                </div>
              ) : (
                <div className='aboard-scale-modify'>
                  <AboardScale
                    singleNo={singleNo}
                    disableScale={disableScale}
                    hidePrice={disableScale}
                    onClick={(no) => setSindleNo(no)}
                  />
                  <AboardModify
                    singleNo={singleNo}
                    onClick={(no) => setSindleNo(no)}
                    wrongFlag={wrongFlag}
                  />
                </div>
              )}
              {
                !Config.buyTogetherId ? (
                  !['combo', 'fullNFree'].includes(targetType) ? (
                    <Reserve
                      no={doProductMobx.doProduct.no}
                      startTime={doProductMobx.doProduct.startTime}
                      pickTimeRange={doProductMobx.doProduct.pickTimeRange}
                      onChange={({ startTime, pickTimeRange }) => {
                        doProductMobx.setStartTime(startTime, pickTimeRange)
                      }}
                    />
                  ) : null
                ) : <></>
              }
            </DetailInfo>
          )}
        </div>
      </IonContent>
      {(targetType && targetNo) || doProductMobx.doProduct.isOrderSwapBuy ? (
        <IonFooter className='footer-btn-wrap'>
          {
            disableReserve ? (
              <div className='footer-btn'>
                <div className='primary-btn disabled'>{i18n.t('newCart.noInReserveTime')}</div>
              </div>
            ) : disableTogo ? (
              <div className='footer-btn'>
                <div className='primary-btn disabled'>{i18n.t('newCart.canNotTogo')}</div>
              </div>
            ) : isOptionalComboGroupFull ? (
              <div className='footer-btn combo-full'>
                {i18n.t('newCart.groupIsFullTips')}
                <div className='reset-btn' data-cypid='productDetailClose' onClick={() => handleBack()}>{i18n.t('newCart.backToCombo')}</div>
              </div>
            ) : (
              <div className='footer-btn'>
                {targetType === 'swapBuy' && (<div className={classNames('primary-btn', { 'disabled': !doProductMobx.doProductResult.isReady })} data-cypid='productDetailChangeEx' onClick={() => handleExChange(targetNo)}>{i18n.t('newCart.confirmExChange')}</div>)}
                {targetType === 'fullNFree' && (<div className={classNames('primary-btn', { 'disabled': !doProductMobx.doProductResult.isReady })} data-cypid='productDetailFullFree' onClick={() => handleFullNFree(targetNo)}>{i18n.t('newCart.confirm')}</div>)}
                {
                  targetType === 'combo' && (
                    <div className={classNames('primary-btn', { 'disabled': !doProductMobx.doProductResult.isReady || doProductMobx.doProduct.saleCnt === 0 })} data-cypid='productDetailConfirm' onClick={handleCombo}>{doProductMobx.doProduct.saleCnt === 0 ? i18n.t('common.soldout') : i18n.t('newCart.confirm')}</div>
                  )
                }
                {doProductMobx.doProduct.isOrderSwapBuy && (<div className={classNames('primary-btn', { 'disabled': !doProductMobx.doProductResult.isReady })} data-cypid='productDetailOrderSwaBuy' onClick={handleOrderSwaBuy}>{i18n.t('newCart.confirmExChange')}</div>)}
              </div>
            )
          }
        </IonFooter>
      ) : (
        <Footer
          disabled={!doProductMobx.doProductResult.isReady || !productMobx.noToIsNotSingleInComboViewProductMap[doProductMobx.doProduct.no]}
          soldOut={doProductMobx.doProduct.saleCnt === 0}
          disableTogo={disableTogo}
          disableReserve={disableReserve}
          restingStore={isRestingStore}
          pauseAllEatType={!isCanAddCart}
          salesCnt={addSalesCnt}
          requiredMinCnt={doProductMobx.doProduct.pk ? cartMobx.getMenuRequiredProductMinCnt(doProductMobx.doProduct.no, doProductMobx.doProduct.cnt) : undefined}
          pauseMobileOrderEndTime={formatTimeByToday(timePickMobx.pauseOrderTime?.endTime)}
          cnt={doProductMobx.doProduct.cnt}
          maxCnt={maxCnt}
          modalFrom={doProductMobx.doProduct.pk ? 'cart' : 'menu'}
          setCnt={(value) => {
            doProductMobx.setCnt(value)
          }}
          totalPrice={doProductMobx.doProductResult.totalPrice}
          totalActualPrice={doProductMobx.doProductResult.totalActualPrice}
          addToCart={() => {
            if (!doProductMobx.doProductResult.isReady || !productMobx.noToIsNotSingleInComboViewProductMap[doProductMobx.doProduct.no]) {
              setSubcolor('colorred')
            }
            if (!productMobx.noToIsNotSingleInComboViewProductMap[doProductMobx.doProduct.no]) {
              handleBack()
              return
            }
            if (doProductMobx.checkInvalid()) {
              showMsg(
                i18n.t('productdetail.saleOutTips2', {
                  count:
                    productSaleMobx.scaleNoToCntMap[
                      `${doProductMobx.doProduct.no}_${doProductMobx.doProduct.scaleNo}`
                    ]?.cnt ||
                    productSaleMobx.menuProductNoToCntMap[
                      `${doProductMobx.doProduct.no}`
                    ]?.cnt,
                })
              )
              return
            }
            // 加料项售罄
            if (doProductMobx.checkModifyInvalid()) {
              showMsg(i18n.t('productdetail.saleOutModifyTips'))
              return
            }
            if (!Config.buyTogetherId ? doProductMobx.checkMaxSalesCnt() : buyTogetherMobx.checkCartItemMaxSalesCnt()) {
              showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: maxSalesCnt }))
              return
            }
            if (doProductMobx.doProductResult.isReady) {
              if (doProductMobx.doProduct && doProductMobx.doProduct.cnt) {
                CashierController.handleAddToCart(doProductMobx.doProduct.type, () => {
                  console.log(123123123123123)
                  handleBack()
                  if (doProductMobx.doProductExt.thirdCouponCheckCB) { // 三方券来的
                    doProductMobx.doProductExt.thirdCouponCheckCB({ status: 'success', type: 'addCart' })
                  }
                })
              } else {
                if (Config.buyTogetherId) {
                  buyTogetherMobx.removeCartItemFromMenu(doProductMobx.doProduct.pk)
                } else {
                  cartMobx.remove(doProductMobx.doProduct.pk)
                }
                handleBack()
              }
            } else {
              handleScollWrong()
              // const unReadyModifier = doProductMobx.doProduct.modifierGroups.find(group => !group.isReady)
              // if (unReadyModifier) {
              //   showMsg(i18n.t('productdetail.chooseModify', { count: unReadyModifier.selectMin, name: unReadyModifier.name }))
              // }
            }
          }}
        />
      )}
    </>
  )
}

export default observer(ProductDetail)
